import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import adddownloadAddress from "./components/adddownloadAddress";
export default {
  name: "downAddress",
  mixins: [loadMoreList, serchSelect],
  components: {
    adddownloadAddress: adddownloadAddress
  },
  data: function data() {
    return {
      pagingReqFn: "downLoadData",
      pagingReqValue: "",
      paramsData: {
        id: '',
        name: '',
        language: '',
        platform_type: ''
      },
      tableBody: 'downloadAddressTable',
      sortReq: 'downloadLinkChangeSort',
      pagingCallback: null
    };
  },
  activated: function activated() {
    this.pagingCallback = this.pagingCallbackFn;
    this.getList();
  },
  methods: {
    pagingCallbackFn: function pagingCallbackFn() {
      var _this = this;

      this.pagingList.map(function (i) {
        var platformTypeName = [];

        _this.platformTypeList.forEach(function (j) {
          if (i.platform_type.findIndex(function (k) {
            return k == j.value;
          }) > -1) {
            platformTypeName.push(j.label);
          }
        });

        i.platformTypeName = platformTypeName.toString();
      });
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'downloadLinkDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};